import React from 'react';
import "@/App.css";
import Header from './components/Header';
import MapAndReviews from './components/MapAndReviews';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-black to-slate-950">
      <Header />
      <MapAndReviews />
      
      {/* Footer */}
      <footer className="py-12 px-4 border-t bg-black/30" style={{ borderTopColor: 'rgba(242, 21, 224, 0.2)' }}>
        <div className="max-w-6xl mx-auto text-center">
          <div className="mb-4 flex justify-center">
            <img 
              src="/images/logo.png" 
              alt="MIAL CAR SERVICE" 
              translate="no"
              className="w-full max-w-xs md:max-w-md h-auto object-contain"
              style={{ imageRendering: 'crisp-edges', filter: 'drop-shadow(0 5px 15px rgba(242, 21, 224, 0.3))' }}
            />
          </div>
          <p className="font-rajdhani text-lg text-gray-300 mb-4">
            Mechanika pojazdowa • Michał Szelągowski
          </p>
          <div className="flex flex-col md:flex-row justify-center items-center space-y-2 md:space-y-0 md:space-x-8 text-gray-400">
            <span>📞 605 056 541</span>
            <span>📍 86-260 Unisław, ul. Głażewska 18</span>
          </div>
          <div className="mt-8 pt-4 border-t border-gray-700">
            <p className="text-gray-500 text-sm">
              © 2026 Mial Car Service. Wszystkie prawa zastrzeżone.
            </p>
            <p className="text-gray-600 text-xs mt-2">
              PR
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
;
